import styled from 'styled-components'
import { Title, Subtitle } from '../components/title'
import { Button } from '../components/button'
import { Text } from '../components/text'

import {
    BsArrowDownCircle,
} from "react-icons/bs";

const StyledSplash = styled.div`
    background-color: ${ props => props.theme.colors.black };
    height: 100vh;
    width: 100vw;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @media print {
        width: 100%;
        height: auto;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 0 0 0.75rem;
        background: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        text-align: left !important;

        h2,
        div,
        p {
            color: #111 !important;
        }

        h2,
        p {
            margin-top: 0.2rem;
        }

        button {
            display: none;
        }
    }
`

const AnimatedArrow = styled(BsArrowDownCircle)`
    @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
        }
        40% {
            transform: translateY(-.3em);
        }
        60% {
            transform: translateY(-.15em);
        }
    }

    @keyframes grow {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.1);
        }
    }

    animation: bounce 2s infinite;

    &:hover {
        animation: none;
    }

    &:active {
        transform: scale(1.1);
    }
`

export const Splash = ({ location, onClick }) => 
    <StyledSplash style={{ textAlign: 'center' }}>
                <Title color='main'>PRDeving</Title>
                <Subtitle color='white'>Engineering Leadership & Architectural Impact</Subtitle>
                <Text color='white'>{ `${location.city}, ${location.country}` }</Text>
                <Button
                    s="margin-top: 1em"
                    onClick={ onClick }
                >
                    <AnimatedArrow size="3em"/>
                </Button>
    </StyledSplash>
